import { PROPERTY_TYPES } from "@rentiohq/shared-frontend/dist/reduxV2/property/property.utils";
export var getImageForProperty = function (property) {
    if (property.images.length > 0) {
        var result = property.images[0];
        if (result) {
            return result;
        }
    }
    return "https://assets.rentio.be/rentio/default-property-image.png";
};
export var getIcon = function (typeId) { var _a; return (_a = PROPERTY_TYPES.find(function (x) { return x.id === typeId; })) === null || _a === void 0 ? void 0 : _a.icon; };
